export const SECONDS_IN_MINUTE = 60;
export const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
export const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;
const SECONDS_IN_WEEK = SECONDS_IN_DAY * 7;

export const TIMEFRAME_UNITS = [
  {
    value: 'minute',
    seconds: SECONDS_IN_MINUTE,
  },
  {
    value: 'hour',
    seconds: SECONDS_IN_HOUR,
  },
  {
    value: 'day',
    seconds: SECONDS_IN_DAY,
  },
  {
    value: 'week',
    seconds: SECONDS_IN_WEEK,
  },
];

// Find timeframe unit which is not larger than given unit
export function getTimeFrameUnitsForMaxUnit(maxUnit: string | undefined | null) {
  let units = [];

  for (let unit of TIMEFRAME_UNITS) {
    units.push(unit);
    if (unit.value === maxUnit) {
      break;
    }
  }

  return units;
}

// Smallest delay granularity is minutes, so remove any stray seconds
export function roundTimeframe(timeframe: number) {
  return Math.floor(timeframe / 60) * 60;
}

// Find largest timeframe unit which evenly divides timeframe
export function findRoundUnit(timeframe: number, units = TIMEFRAME_UNITS) {
  let [timeframeUnit] = units;

  units.forEach((unit) => {
    if (timeframe % unit.seconds === 0) {
      timeframeUnit = unit;
    }
  });

  return timeframeUnit;
}

export function countToSeconds(count: number, unit: string) {
  if (isNaN(count) || count <= 0) {
    return 0;
  }

  let { seconds } = TIMEFRAME_UNITS.findBy('value', unit)!;

  return count * seconds;
}
